import React from "react";
import { Route } from "react-router-dom";
import { MergingListCard } from "./MergingListCard";
import { MergingListEditDialog } from "./mergingList-edit-dialog/MergingListEditDialog";
import { MergingListUIProvider } from "./MergingListUIContext";
import { PrivateRoute } from "../../../PrivateRoute";
import { BlockOrg, RoleChecker } from "../../../RoleChecker";

export function MergingListPage({ history }) {
  const mergingListUIEvents = {
    newMergingListButtonClick: () => {
      history.push("/kurban/merging/new");
    },
    openEditMergingListPage: (id) => {
      history.push(`/kurban/merging/${id}`);
    },
  };

  return (
    <MergingListUIProvider mergingListUIEvents={mergingListUIEvents}>
      <MergingListCard />
    </MergingListUIProvider>
  );
}
